import React, { useMemo } from 'react';
import { Modal, ModalBody, Table } from 'reactstrap';
import modalclose from '../../../images/close1.png';
import './index.css';

const OrderSummaryModal = ({ isOpen, toggle, orderData }) => {
  const products = useMemo(() => orderData.order_product_data || [], [
    orderData,
  ]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered id="FulfilledSummaryModal">
      <ModalBody className="p-0">
        <div className="modalHeader mb-0">
          <div className="title">
            ORDER SUMMARY ({orderData.dealership_name})
          </div>
          <div className="closeButton">
            <img src={modalclose} alt="close" onClick={toggle} />
          </div>
        </div>
        <div className="bodyArea">
          <Table responsive bordered>
            <thead>
              <tr>
                <th rowSpan={2}>Sr No.</th>
                <th rowSpan={2}>Material Details</th>
                <th>No. of packages</th>
                <th>Total Quantity</th>
                <th rowSpan={2}>Status</th>
                <th rowSpan={2}>Remarks</th>
              </tr>
              <tr>
                <th>Actual/Accepted</th>
                <th>Actual/Accepted</th>
              </tr>
            </thead>
            <tbody>
              {products.map((data, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{data.name || '-'}</td>
                    <td>
                      {data.qty || '-'}/{data.no_of_packages || '-'}
                    </td>
                    <td>
                      {data.total_quantity || '-'}/
                      {data.accepted_quantity || '-'}
                    </td>
                    <td
                      style={{
                        color:
                          data.action === 'Accepted'
                            ? 'green'
                            : data.action === 'Rejected'
                            ? 'red'
                            : data.action === 'Partially Accepted'
                            ? 'blue'
                            : 'black',
                      }}
                    >
                      {data.action === 'Accepted'
                        ? 'Accepted'
                        : data.action === 'Rejected'
                        ? 'Rejected'
                        : data.action === 'Partially Accepted'
                        ? 'Partially Accepted'
                        : '-'}
                    </td>
                    <td>{data.action_reason}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OrderSummaryModal;
